<!--
====================================================================
Copyright 2024-2025 EcoNet.NZ

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
====================================================================
-->
<template>
  <div class="grid">
    <div class="col-12 md:col-6 mx-auto">
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="text-900 text-3xl font-medium mb-4">Changelog</div>
        <h2 class="text-xl font-medium text-900 mt-0 mb-3">Version {{ version }}</h2>
        <ul v-if="changes.length" class="changelog-list">
          <li v-for="change in changes" :key="change">{{ change }}</li>
        </ul>
        <p v-else class="text-700 mt-0">No changelog notes for this version yet.</p>
        <p class="mt-4 mb-0">
          <a href="#" @click.prevent="goBack">Back to the editor</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const NOTES = {
  '0.8.3': [
    'Treatment Details is limited to 256 characters, Location Notes to 96, and Notes to 3000, matching CAMS. Treatment Details on iNaturalist uses the same 256-character limit. Text that is longer is shortened and ends with ...',
    'Easy Editor suggests a date for the next visit for Moth Plant, Old Man\'s Beard, Cathedral Bells, Banana Passionfruit, Blue Passion Flower, Pink Jasmine, Japanese Honeysuckle, Blue Morning Glory, Woolly Nightshade, and Elaeagnus. CAMS Jasmine (Pink), stored as Jasmine, is included. Other species leave the date blank.',
    'Yellow and orange statuses suggest 1 October the same year when the visit is before 1 August, and 1 October the next year from 1 August onward.',
    'Green and pink statuses suggest 1 October the next year when the visit is before 1 October, and 1 October two years later on or after 1 October.',
    'If that 1 October is not after today, the suggestion moves forward one year at a time until it is. A date more than 5 years after today is not suggested.',
    'When a date is calculated, it is required. Clearing it shows a red border and saving stays disabled until you enter a date. You can still change the suggested date.',
    'The latest next visit date is 5 years after today.',
    'The date field is shown for Controlled, Alive, and Dead, including as soon as Alive is selected. Duplicate hides the field. Red statuses leave the date blank, and that blank date is not required.',
    'Opening the calendar shows the month of the date already in the box.',
    'The version number at the bottom of the editor opens this page.',
  ],
}

export default {
  name: 'VersionChangelog',
  props: {
    version: {
      type: String,
      default: '',
    },
  },
  computed: {
    changes() {
      return NOTES[this.version] || []
    },
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        window.history.back()
        return
      }
      const base = process.env.BASE_URL || '/'
      window.location.href = base
    },
  },
}
</script>

<style scoped>
.changelog-list {
  margin: 0;
  padding-left: 1.25rem;
  color: #374151;
  line-height: 1.5;
}

.changelog-list li + li {
  margin-top: 0.75rem;
}
</style>
